import React from 'react'
import { withPopover } from 'components/HOC/AntdWrapper'
import { get } from 'lodash'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'

interface Props {
  acitveGroupId: any
  levelStore: any
  setActiveGroup: any
}

class CheckGroup extends ComponentExt<Props> {
  constructor(props) {
    super(props)
  }

  state = {
    groupPosition: 0,
  }

  render() {
    const { levelStore, acitveGroupId, setActiveGroup } = this.props
    const check_template = get(
      levelStore,
      'userCheckRecord.meta.check_template',
    )

    const groupBarWrapperWidth = () => {
      const numOfCheckGroups =
        check_template && check_template.check_groups
          ? check_template.check_groups.length
          : 0
      return numOfCheckGroups * 104 + (numOfCheckGroups - 1) * 100
    }
    const moveCheckGroup = (moveNum: number): void => {
      const btnWidth = 104
      const btnMarginRight = 100
      let positionNumber = this.state.groupPosition
      positionNumber =
        this.state.groupPosition + -1 * moveNum * (btnWidth + btnMarginRight)

      if (positionNumber >= 0) {
        positionNumber = 0
      } else if (positionNumber <= -groupBarWrapperWidth()) {
        positionNumber = -groupBarWrapperWidth() + btnWidth
      }
      this.setState({
        groupPosition: positionNumber,
      })
    }

    const check_groups =
      check_template && check_template.check_groups
        ? check_template.check_groups
        : []

    return (
      <div className={styles.levelMode}>
        <ul className={styles.checkGroup}>
          {check_groups && check_groups.length > 4 && (
            <li
              className={`${styles.groupItem} ${styles.groupBtn} ${
                styles.groupPrevBtn
              }`}
              onClick={() => moveCheckGroup(-1)}
            />
          )}

          <li className={`${styles.groupItem} ${styles.groupBarWrapper}`}>
            <div
              style={{
                position: 'relative',
                left: this.state.groupPosition,
                transition: 'all .6s',
                width: groupBarWrapperWidth(),
              }}
            >
              {check_groups &&
                check_groups.map((item, index) => {
                  return withPopover({
                    content: item.name,
                    placement: 'top',
                    overlayClassName: 'group-item-popover',
                  })(
                    <a
                      key={item.id}
                      onClick={() =>
                        setActiveGroup(
                          acitveGroupId === item.id ? -1 : index,
                          item.id,
                        )
                      }
                      className={`${styles.groupItemBtn} ${
                        acitveGroupId === item.id ? styles.active : ''
                      }`}
                    >
                      {item.name && item.name.slice(0, 4)}
                    </a>,
                  )
                })}
            </div>
          </li>
          {check_groups && check_groups.length > 4 && (
            <li
              className={`${styles.groupItem} ${styles.groupBtn} ${
                styles.groupNextBtn
              }`}
              onClick={() => moveCheckGroup(1)}
            />
          )}
        </ul>{' '}
      </div>
    )
  }
}
export default CheckGroup
